// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__NC6Re","loader":"MediumLoader_loader__rHgln","spinner-c7wet2":"MediumLoader_spinner-c7wet2__2JvVU"};